//#region Styles
import {
    Column, 
    Part, 
    TitleSection, 
    Fields 
} from "components/styles";
//#endregion
//#region Components
import OnlyDayFields from "views/components/Duration/OnlyDayFields/OnlyDayFields";
//#endregion

const Part2 = ({ 
    form, changeField, 
    changeErrorText, 
    errors, errorTexts
}) => {
    //#region Functions
    const changeDuration = (value, errorsValue) => {
        changeField("duration", value, errorsValue);
    };
    //#endregion
    return (
        <Part paddingBottom="80px">
            <Fields>
                <Column>
                    <Column>
                        <TitleSection>Duración</TitleSection>
                    </Column>
                    <OnlyDayFields
                        duration={form.duration}
                        changeDuration={changeDuration}
                        changeErrorText={changeErrorText}
                        errors={errors.duration}
                        errorTexts={errorTexts}/>
                </Column>
            </Fields>
        </Part>
    );
}

export default Part2;